// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"230":"d3e28086bfb0366fec0c","573":"e5f3bc80bb51a65e8e05"}[chunkId] + ".2131.js";
};